import React from 'react';
import { CONFIG } from '~/_shared/constants/config';
import {
  type ModalComponentMap, type ModalName, type ModalRegistryProps,
} from './modalRegistry.type';

class DynamicRenderer {
  private registry: ModalComponentMap = {};

  register<K extends ModalName>(
    name: K,
    component: React.ComponentType<ModalRegistryProps<K>>
  ) {
    this.registry[name] = component as any;
  }

  isRegistered(name: ModalName | string): name is ModalName {
    return !!this.registry[name as ModalName];
  }

  render<K extends ModalName>(
    name: K,
    props: ModalRegistryProps<K>,
    id: string,
  ): React.ReactElement | null {
    const Component = this.registry[name] as React.ComponentType<any>;

    if (!Component) {
      console.warn(`Modal ${name} not registered.`);
      return null;
    }

    return (
      <Component
        key={id}
        {...props}
      />
    );
  }
}

export const modalRenderer = new DynamicRenderer();

if (CONFIG.MODE === 'development') {
  Object.assign(window, { modalRenderer });
}
